

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const CREATEDEPARTMENT= createAsyncThunk(
  "createDepartment/createDepartment",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const createDepartmentSlice = createSlice({
  name: "createDepartmentSlice",
  initialState: {
    createDepartment: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfcreateDepartment: (state) => {
        state.createDepartment.loading = false
        state.createDepartment.error = false
        state.createDepartment.data = []
        state.createDepartment.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(CREATEDEPARTMENT.fulfilled, (state, action) => {
      state.createDepartment = {
        ...state.createDepartment,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(CREATEDEPARTMENT.pending, (state, action) => {
      state.createDepartment = {
        ...state.createDepartment,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(CREATEDEPARTMENT.rejected, (state, action) => {
      state.createDepartment = {
        ...state.createDepartment,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const createDepartmentAction = {
    CREATEDEPARTMENT,
};

export { createDepartmentAction };
export default createDepartmentSlice.reducer;
export const {setInitialStateOfcreateDepartment} = createDepartmentSlice.actions
